import { useState, useEffect } from 'react'
import { useTranslation } from '@mc/i18n'
import { TOTAL_TIME_IN_LOGO } from './constants'

interface UseQuizLoadingScreenBulletsWayfinding {
  logoAnimationFinished: boolean
}

export const BULLETS_COUNT = 3
export const TIME_PER_BULLET = TOTAL_TIME_IN_LOGO / BULLETS_COUNT

export const useQuizLoadingScreenBulletsWayfinding = ({
  logoAnimationFinished,
}: UseQuizLoadingScreenBulletsWayfinding) => {
  const { t } = useTranslation('@mc/next')
  const bulletsCopy: string[] = t('findMyClasses.bullets', {
    returnObjects: true,
  })

  const [currentCopyIndex, setCurrentCopyIndex] = useState(0)
  const currentBullets = bulletsCopy.slice(0, currentCopyIndex + 1)

  useEffect(() => {
    if (!logoAnimationFinished && bulletsCopy?.length) {
      const bulletInterval = setInterval(() => {
        if (currentCopyIndex < bulletsCopy.length) {
          setCurrentCopyIndex(currentCopyIndex + 1)
        }
      }, TIME_PER_BULLET)

      return () => clearInterval(bulletInterval)
    }

    return () => {}
  }, [logoAnimationFinished, bulletsCopy, currentCopyIndex])

  return { currentBullets }
}
